import { getAuthToken } from '@/utils/helpers/auth';
import { Navigate, Outlet } from 'react-router-dom';

export const PublicRoute = () => {
  return getAuthToken() ? <Navigate to={'/children'} /> : <Outlet />;
};
